export default __webpack_public_path__ + "static/media/mfcc.5329eb5d.png";